import React from 'react'
import injectSheet from 'react-jss'
import styles from './archived-entry.styles'
import { Cell, TableRow } from 'pobble-components/dist/table'
import CircleStatus from 'pobble-components/dist/circle-status'
import { Link } from 'react-router-dom'

const ArchivedEntry = ({
  classes,
  id,
  title,
  invitedAt,
  invitedBy,
  conclusion,
  pending,
  link
}) => (
  <TableRow pending={pending}>
    <Cell className={classes.date}>{invitedAt}</Cell>
    <Cell>{invitedBy}</Cell>
    <Cell>
      <Link className={classes.link} to={link}>
        {title}
      </Link>
    </Cell>
    <Cell className={classes.center}>
      <CircleStatus status={conclusion} />
    </Cell>
  </TableRow>
)

export default injectSheet(styles)(ArchivedEntry)
